<template>
  <div class="Progress">
    <v-container fluid fill-height>
      <v-layout
        justify-center
        align-center
      >
        <v-flex xs12 md9>
          <v-card class="mb-2">
            <v-card-title class="title">
              Avance General del Operativo
            </v-card-title>

            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <!-- TODO: Mejorar vista en pantalla vertical -->
            <!-- <v-card-text v-else class="hidden-xs-only"> -->
            <v-card-text v-else>
              <chart-line
                :chartOptions="chartOptions"
                :chartSeries="chartSeries"
                :key="chartKey"
              />
            </v-card-text>

            <!-- Brush
          https://apexcharts.com/vue-chart-demos/line-charts/brush-chart/ -->
            <!-- <v-card-text>
              <apexchart
                type="line"
                height="230"
                :options="chartOptions"
                :series="series"
              ></apexchart>
            </v-card-text>

            <v-card-text>
              <apexchart
                type="area"
                height="130"
                :options="chartOptionsLine"
                :series="seriesLine"
              ></apexchart>
            </v-card-text> -->
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import chartLine from '@/components/Charts/LineBase'

export default {
  name: 'Progress',

  components: {
    'chart-line': chartLine
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
    this.loadProgress()
  },

  watch: {
    '$store.state.actualOperation': function () {
      this.operativo = this.$store.state.actualOperation.id
    }
  },

  data: function () {
    return {
      backConf: {
        path: '/charts/avancegeneral',
        page: 1
      },

      operativo: null,

      loading: false,
      progressSize: 70,
      progressWidth: 7,
      chartKey: 0,
      chartSeries: null,

      chartOptions: {
        chart: {
          zoom: {
            type: 'x',
            enabled: true
          }
        },
        colors: ['#008FFB', '#00E396', '#FF4560'],
        dataLabels: {
          enabled: true
        },
        legend: {
          show: true,
          position: 'bottom'
        },
        stroke: {
          curve: 'smooth'
        },

        responsive: [
          {
            breakpoint: 721,
            options: {
              legend: {
                position: 'bottom'
              }
            }
          }
        ],

        markers: {
          size: 5,
          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          type: 'datetime',
          labels: {
            rotate: -15,
            rotateAlways: true
          },
          title: {
            text: 'Fecha'
          }
        },
        yaxis: [
          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: '#008FFB'
            },
            labels: {
              style: {
                color: '#008FFB'
              }
            },
            title: {
              text: 'Avance Diario',
              style: {
                color: '#008FFB'
              }
            },
            tooltip: {
              enabled: true
            }
          },
          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: '#00E396'
            },
            labels: {
              style: {
                color: '#00E396'
              }
            },
            opposite: true,
            title: {
              text: 'Avance Acumulado',
              style: {
                color: '#00E396'
              }
            },
            tooltip: {
              enabled: true
            }
          },
          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: '#FF4560'
            },
            labels: {
              style: {
                color: '#FF4560'
              }
            },
            opposite: true,
            title: {
              text: 'No Efectividad',
              style: {
                color: '#FF4560'
              }
            },
            tooltip: {
              enabled: true
            }
          }
        ]
        // tooltip: {
        //   fixed: {
        //     enabled: true,
        //     position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
        //     offsetY: 30,
        //     offsetX: 60
        //   }
        // }
      }
    }
  },

  methods: {
    /**
     * Carga los datos de avance general y acumulado
     */
    loadProgress () {
      this.loading = true
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.chartSeries = resp.data
          // t.chartSeries.pop()
          // t.chartOptions.yaxis.pop()
          t.loading = false
          t.chartKey += 1
        })
        .catch(err => console.error(err))
    }
  }
}
</script>
